import React, { useCallback, useEffect, useState, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import classNames from 'classnames';
import { PolicyChange, messages } from 'gw-capability-policychange-common-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService, MLTagManagerService, AskServiceOpsService } from 'ml-portals-services-react';
import { MLLocalDateUtil, MLEndorsementFlowUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import {MLNavigationStepsTrackingService, MLClickToChatService} from 'ml-services-common-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { platformMessages } from 'ml-components-platform-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import paWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-policychange-wizard-config.json5';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { ClauseService } from 'gw-capability-policycommon';

import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';

import hoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-wizard-config.json5';
import pupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-wizard-config.json5';
import ampPaWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-amp-wizard-config.json5';
import ampHoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-amp-wizard-config.json5';
import ampPupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-amp-wizard-config.json5';
import localMessages from './PolicyChangePage.messages';

import metadata from './PolicyChangePage.metadata.json5';
import styles from './PolicyChangePage.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import {MLPortalSettingsService} from "gw-capability-quoteandbind";

const ADDITIONAL_CHANGES_STATE = 'endorsementAdditionalChanges';


// V9 - MLEffectiveDateCtrl
function PolicyChangePage(props) {
    const { 
        showProgressDialog,
    } = MLModalService();

    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const {
        updateWizardData, wizardData, goNext, changeNextSteps, steps: currentSteps, currentStepIndex, history
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const { submissionVM } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { onValidate } = useValidation('PAPolicyChange');
    const isAmp = appConfig.portalCode === 'AMP';
    const isAgent = appConfig.agentendorsement === 'true';
    const isGPA = appConfig.portalCode === 'GPA';
    const { MLUserTypes } = appConfig;
    const askSoService = AskServiceOpsService();

    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isPersonalAuto = MLProductCodeUtil.isPersonalAuto(productCode);
    const isHomeowners = MLProductCodeUtil.isHomeOwners(productCode);
    const isPersonalUmbrella = MLProductCodeUtil.isPersonalUmbrella(productCode);
    const unfilteredInitiatorTypeList = _.get(submissionVM, 'baseData.initiator_ML.aspects.availableValues', []);

    let wizardConfig;
    if (isAmp) {
        if (isPersonalAuto) {
            wizardConfig = ampPaWizardConfig;
        } else if (isHomeowners) {
            wizardConfig = ampHoWizardConfig;
        } else {
            wizardConfig = ampPupWizardConfig;
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (isPersonalAuto) {
            wizardConfig = paWizardConfig;
        } else if (isHomeowners) {
            wizardConfig = hoWizardConfig;
        } else {
            wizardConfig = pupWizardConfig;
        }
    }
    const { steps } = wizardConfig;

    // store the existing effective date in case it is overwritten
    const [existingEffectiveDate] = useState(_.get(submissionVM, 'baseData.effectiveDate.value'));
    const [ampPriorEffectiveDateAdjusted, setAmpPriorEffectiveDateAdjusted] = useState(false);
    const [latestPolicyChangeEffectiveDate, setLatestPolicyChangeEffectiveDate] = useState(undefined);

    const [existingChangeWarningMessagePart1, setExistingChangeWarningMessagePart1] = useState(undefined);
    const [existingChangeWarningMessagePart2, setExistingChangeWarningMessagePart2] = useState(undefined);
    const [existingChangeWarningActionButton, setExistingChangeWarningActionButton] = useState(undefined);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [showErrors, updateShowErrors] = useState(false);

    const [today] = useState(() => {
        const t = new Date();
        t.setHours(0, 0, 0, 0);
        return {
            year: t.getFullYear(),
            month: t.getMonth(),
            day: t.getDate()
        }
    });

    const {
        addWarningAlert,
        clearWarningAlerts,
        clearBlockAlerts,
        addSuccessAlert,
        clearAlerts
    } = MLNotificationBlockUtil();

    const userType = _.get(submissionVM, 'baseData.userType_ML.value');

    const isUserIAeaMetGA = userType.code === MLUserTypes.IA || userType.code === MLUserTypes.PCS || userType.code === MLUserTypes.MET_GA

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const getGroupSettings = useCallback(() => {
        return MLPortalSettingsService.getSettings(authHeader);
    }, [authHeader]);

    const _deleteConfirmationMessage = () => {
        clearAlerts();
        addSuccessAlert(<p><strong>{translator(localMessages.deleteConfirmationAlertText1)}</strong><span>{translator(localMessages.deleteConfirmationAlertText2)}</span></p>)
        };

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Effective Date Screen'}, submissionVM, authHeader)
    }, [])

    useEffect(() => {
        const groupPromise = getGroupSettings();
        groupPromise.then((response) => {
            const { groupAffiliationSettings } = response;
            sessionStorage.setItem('groupScreenSettings', JSON.stringify(groupAffiliationSettings));
        }).catch(() => {
            sessionStorage.setItem('groupScreenSettings', null);
        });

        if (submissionVM.value.hasValidQuote() && !isAmp) {
            const index = _.findIndex(steps, ({ mlStepName }) => mlStepName === 'endorsementQuoteDetails');
            if (index > 0) {
                const remainingSteps = steps.slice(index, steps.length);
                changeNextSteps(remainingSteps);
            }
            if (!submissionVM.value.editEffectiveDate) {
                MLNavigationStepsTrackingService.init('PolicyChange', productCode, translator, 'endorsementQuoteDetails')
                goNext();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Policy Change Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const retrieveLatestBoundPolicyChangeEffectiveDate = useCallback(() => {
        const promise = EndorsementService.getLatestBoundPolicyChangeEffectiveDate(submissionVM.policyNumber.value, authHeader);

        showProgressDialog(messages.loadingPolicyChange, promise);
        promise.then((latestBoundEffectiveDate) => {
            setLatestPolicyChangeEffectiveDate(latestBoundEffectiveDate);

            if (latestBoundEffectiveDate) {
                const isBoundDateLaterThanToday = MLLocalDateUtil.localDate2Date(latestBoundEffectiveDate) >= MLLocalDateUtil.localDate2Date(today);
                const isBoundDateLaterThanExistingDate = MLLocalDateUtil.localDate2Date(latestBoundEffectiveDate) >= MLLocalDateUtil.localDate2Date(existingEffectiveDate);

                if (isBoundDateLaterThanToday && isBoundDateLaterThanExistingDate) {
                    _.set(submissionVM, 'baseData.effectiveDate.value', latestBoundEffectiveDate);

                    if (MLNavigationStepsTrackingService.getData() && !MLNavigationStepsTrackingService.getData().effectiveDate) {
                        MLNavigationStepsTrackingService.setOriginalEffectiveDate(submissionVM.baseData.effectiveDate.value);
                    }
                }
            }
        });
    }, [EndorsementService, authHeader, existingEffectiveDate, showProgressDialog, submissionVM, today]);


    const setPriorEffectiveDateToTodayIfEndorsementIsNewOrItIsAmp = useCallback(() => {
        const isExistingAmpChange = submissionVM.jobID.value && isAmp;
        if (!submissionVM.jobID.value || isExistingAmpChange) {
            if (!(MLLocalDateUtil.localDate2Date(submissionVM.baseData.effectiveDate.value) > MLLocalDateUtil.localDate2Date(today))) {
                _.set(submissionVM, 'baseData.effectiveDate.value', today);
                setAmpPriorEffectiveDateAdjusted(isExistingAmpChange);
            }
        }
    }, [isAmp, submissionVM, today]);

    const defaultTransactionRequestedByAgent = (vm) => {
        vm.baseData.transactionRequestedByAgent_Ext.value = true;
    };

    const isOutOfSequence = () => {
        return !!latestPolicyChangeEffectiveDate
            && MLLocalDateUtil.compare(submissionVM.baseData.effectiveDate.value, latestPolicyChangeEffectiveDate) < 0;
    };

    const addOutOfSequenceWarningMessage = () => {
        if (!latestPolicyChangeEffectiveDate) {
            return;
        }
        const date = MLLocalDateUtil.localDate2Date(latestPolicyChangeEffectiveDate).toLocaleDateString();
        const message = isAgent === true ? localMessages.oosTransaction : {...localMessages.oosDate, args: {date}};
        addWarningAlert(message, "oosWarning");
    };

    useEffect(() => {
        clearBlockAlerts("oosWarning");
        if(isOutOfSequence()){
            addOutOfSequenceWarningMessage();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [latestPolicyChangeEffectiveDate, submissionVM.baseData.effectiveDate.value])

    
    const setExistingChangeBannerMessage = () => {
        const effDate = _.get(submissionVM, 'baseData.effectiveDate.value');
        const formattedDate = MLLocalDateUtil.localDate2Date(effDate)?.toLocaleDateString();
        let part1;
        let part2;
        if (_.get(submissionVM, 'jobID.value')) {
            switch (userType.code) {
                case ('other'):
                    if (ampPriorEffectiveDateAdjusted) {
                        part1 = <FormattedMessage
                            {...localMessages.existingChangeAmp1}
                            values={{
                                details: (
                                    <strong>{translator(localMessages.existingChangeBold)}</strong>
                                ),
                                date: formattedDate
                            }}
                        />
                        part2 = translator(localMessages.existingChangeAmp2ChatEmail);
                    } else {
                        part1 = translator(localMessages.existingChangeAmp1NonAdjustedDate);
                        part2 = translator(localMessages.existingChangeAmp2);
                    }
                    break;
                case (MLUserTypes.IA):
                case (MLUserTypes.PCS):
                case (MLUserTypes.MET_GA):
                    part1 = <FormattedMessage
                        {...localMessages.existingChangeGA1}
                        values={{
                            bold: (
                                <strong>{translator(localMessages.existingChangeBoldGa)}</strong>
                            ),
                            date: formattedDate
                        }}
                    />;
                    part2 = translator(localMessages.existingChangeGA2);
                    break;
                case (MLUserTypes.GCS_SALES):
                case (MLUserTypes.GCS_SERVICING):
                    part1 = <FormattedMessage
                        {...localMessages.existingChangeGA1}
                        values={{
                            bold: (
                                <strong>{translator(localMessages.existingChangeBoldGa)}</strong>
                            ),
                            date: formattedDate
                        }}
                    />;
                    part2 = translator(localMessages.existingChangeGCS);
                    break;
                default:
                    break;
            }
        } else {
            defaultTransactionRequestedByAgent(submissionVM);
        }
        setExistingChangeWarningMessagePart1(part1);
        setExistingChangeWarningMessagePart2(part2);
        setExistingChangeWarningActionButton(translator(localMessages.discardAllChanges));
    };

    const getInitiatorAvailableValues = () => {
        let initiatorTypeList = {};

        if (!isAmp) {
            initiatorTypeList = unfilteredInitiatorTypeList.filter((initiatorType) => {
                return initiatorType.code !== 'automated';
            });
        }
        else {
            initiatorTypeList = unfilteredInitiatorTypeList;
        }

        return initiatorTypeList.map((availableValue) => ({
            belongsToCategory: availableValue.belongsToCategory,
            code: availableValue.code,
            displayName: {
                defaultMessage: availableValue.name,
                id: availableValue.name,
            },
            id: availableValue.code,
            priority: availableValue.priority,
            typelist: availableValue.typelist,
        }));
    };

    const withdraw = useCallback(() => {
        const policyNumber = submissionVM.value.policyNumber;
        const chosenStepPathML = submissionVM.value.chosenStepPathML;
        MLTagManagerService.sendLinkClickEvent('Discard All Changes');
        const withdrawPromise = EndorsementService.withdrawEndorsement([submissionVM.value.jobID], authHeader);
        showProgressDialog(localMessages.withdrawingPolicyChange, withdrawPromise);
        withdrawPromise.then(() => {
            MLNavigationStepsTrackingService.clearDynamicSteps();
            const loadPromise = EndorsementService.loadEndorsement(policyNumber, authHeader);
            showProgressDialog(localMessages.loadingPolicyChange, loadPromise);
            loadPromise.then((policyChangeData) => {
                const policyChange = new PolicyChange(policyChangeData);
                const vm = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                _.set(vm, 'baseData.initiator_ML.value', submissionVM.baseData.initiator_ML.value);
                _.set(vm, 'value.chosenStepPathML', chosenStepPathML);
                updateWizardSubmissionData(vm);
                clearWarningAlerts();
                _deleteConfirmationMessage();
            });
        });
    }, [EndorsementService, authHeader, clearWarningAlerts, showProgressDialog, submissionVM, updateWizardSubmissionData, viewModelService]);

    useEffect(() => {
        if (submissionVM.value.hasValidQuote() && !isAmp) {
            return
        }

        const showChangeInProgressWarning = (existingChangeWarningMessagePart1 || existingChangeWarningMessagePart2) && submissionVM.value.chosenStepPathML !== ADDITIONAL_CHANGES_STATE
        if (showChangeInProgressWarning) {
            addWarningAlert({...localMessages.existingChangeAlert, args: {
                msg1: existingChangeWarningMessagePart1,
                btnMsg: existingChangeWarningActionButton,
                msg2: existingChangeWarningMessagePart2
            }}, null, withdraw);

            MLNavigationStepsTrackingService.retrieveFromPortalStorageEndorsement(submissionVM.jobID.value, authHeader, refreshData);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [existingChangeWarningMessagePart1, existingChangeWarningMessagePart2]);

    const onNext = useCallback(() => {
        clearWarningAlerts();
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            addWarningAlert(platformMessages.mlErrorOccurredWarning, 'errorOccurredWarning');
            setErrorTimestamp(errorTimestamp+1);
            updateShowErrors(true);
            return;
        }


        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(localMessages.checkingEffectiveDate, promise);
        promise.then((updatedPolicyChange) => {
            MLNavigationStepsTrackingService.setJobNumber(updatedPolicyChange.jobID);
            MLTagManagerService.sendFormStepPolicyChangeStep();

            const chosenStepPathML = submissionVM.value.chosenStepPathML;
            const policyChange = new PolicyChange(Object.assign({}, updatedPolicyChange, { chosenStepPathML }));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                 
            if (isGPA) {
                PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                    step: 'PolChange Policy Change Screen',
                    action: 'Policy Change Submitted'
                });
            }

            if (chosenStepPathML) { // Add chosen step as next step in flow
                MLNavigationStepsTrackingService.completeCurrentStep(null, authHeader);
                const chosenStepObj = steps.find((s) => s.path === chosenStepPathML);
                const newSteps = [...currentSteps];
                newSteps[0] = chosenStepObj;
                changeNextSteps(newSteps);
                updatedEndorsementVM.value.stayOnStepML = true;
            }
            updateWizardSubmissionData(updatedEndorsementVM);

            ClausesUtil.getDependentClausesFromServer(
                ClauseService,
                _.get(updatedPolicyChange, 'jobID'),
                authHeader
            );            
            goNext();
        });
    }, [clearWarningAlerts, submissionVM.aspects.valid, submissionVM.aspects.subtreeValid, submissionVM.value, EndorsementService,
        authHeader, showProgressDialog, addWarningAlert, errorTimestamp, viewModelService, updateWizardSubmissionData, goNext,
        steps, currentSteps, changeNextSteps]);

    const resetInitiator = () => {
        if (submissionVM && submissionVM.baseData.initiator_ML
            && submissionVM.baseData.initiator_ML.value && 
            submissionVM.baseData.initiator_ML.value.code === "automated") {
            // Resetting the initiator if the PolicyChange triggered automated
            _.set(submissionVM,'baseData.initiator_ML',undefined)
            updateWizardSubmissionData(submissionVM)
        }
    }

    // Initial Load
    useEffect(() => {
        resetInitiator()
        MLClickToChatService.setChatData(
            { 'W2C_Policy_Number__c': submissionVM.policyNumber.value}, isAmp ? 'AMP' : 'GPA'
        );

        askSoService.storeCurrentPageData(submissionVM.value.baseData.policyContact_ML.primaryAddress.state, submissionVM.policyNumber.value, '', '');
  
        if (submissionVM.value.hasValidQuote() && !isAmp) {
            return
        }

        setPriorEffectiveDateToTodayIfEndorsementIsNewOrItIsAmp();
        retrieveLatestBoundPolicyChangeEffectiveDate();
        setExistingChangeBannerMessage();
        MLEndorsementFlowUtil.updateAvailableSteps(currentSteps, currentStepIndex, changeNextSteps);

        if (!isAgent) {
            _.set(submissionVM, 'baseData.initiator_ML.value', 'insured');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isUserIAeaMetGA) {
        _.set(submissionVM, 'baseData.initiator_ML.value', 'agent');
    }

    const displayTransactionRequestedByAgent = () => {
        return submissionVM.baseData.userType_ML.value.code !== MLUserTypes.IA 
            && submissionVM.baseData.userType_ML.value.code !== MLUserTypes.PCS
    }

    const overrideProps = {
        effectiveDatePageContainer: {
            className: isAmp ? 'ml-effective-date' : 'ml-effective-date page-content-gpa-policy-change'
        },
        effDateContainer: {
            className: isAmp ? 'col-md-6' : 'col-md-3'
        },
        effDateTooltipContainer: {
            visible: !isAgent
        },
        effectiveDateTooltip: {
            tooltipLabel: platformMessages.mlWhatDoesItMean,
            tooltipContent: localMessages.tooltipMessage
        },
        initiatorRow: {
            visible: !isUserIAeaMetGA
        },
        initiatorField: {
            availableValues: getInitiatorAvailableValues()
        },
        transactionRequestedByAgentRow: {
            visible: displayTransactionRequestedByAgent()
        },
        footer: {
            className: classNames('ml-cta-sub-footer col-md-12', isAmp ? styles.noTopMargin : '')
        },
        nextDescription: {
            content: <FormattedMessage
                {...localMessages.nextDescription}
                values={{
                    details: (
                        <strong>{translator(localMessages.nextDetails)}</strong>
                    )
                }}
            />
        }
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            policyChangePageHeaderML={isAmp ? localMessages.updatePolicyHeader : localMessages.makeChangesHeader}
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

PolicyChangePage.propTypes = wizardProps;
export default withRouter(PolicyChangePage);
